export interface NewsletterItem {
  type: string;
  name: string;
  frequency: string | null;
  description: string;
  image: string;
  subscribed: boolean;
  espId: number;
  loading: boolean;
  subscriberOnly: boolean;
}

export interface NewsletterCategory {
  title: string;
  description: string | null;
  items: NewsletterItem[];
}

export const newsletterCategories: NewsletterCategory[] = [
  {
    title: 'Pasirinkite pagal temas',
    description: null,
    items: [
      {
        type: 'topic',
        name: 'Lietuvos ir pasaulio naujienos',
        frequency: 'Kiekvieną dieną',
        description:
          'Svarbiausi įvykiai iš Lietuvos ir pasaulio tiesiai į jūsų pašto dėžutę. Sužinokite, kas vyksta čia ir dabar, ir nepraleiskite to, kas svarbiausia.',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/topic_lietuvoje.png',
        subscribed: false,
        espId: 10281,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'topic',
        name: 'Verslo naujienos',
        frequency: 'Ketvirtadieniais',
        description: 'Svarbiausios verslo naujienos ir įžvalgos. Sužinokite, kas formuoja verslo pasaulį šiandien.',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/topic_verslas.png',
        subscribed: false,
        espId: 10282,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'topic',
        name: 'Sveikatos naujienos',
        frequency: 'Pirmadieniais',
        description: 'Nuo naujausių medicinos atradimų iki kasdienių sveikatos ritualų – visa, ko reikia gerai savijautai ir gyvenimo kokybei.',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/topic_sveikata.png',
        subscribed: false,
        espId: 10284,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'topic',
        name: 'Mokslas ir IT naujienos',
        frequency: 'Trečiadieniais',
        description: 'Čia sužinosite apie naujausius atradimus archeologijoje, kosmose, medicinoje, dirbtinio intelekto srityje bei kitas inovacijas.',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/topic_mokslas.png',
        subscribed: false,
        espId: 10285,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'topic',
        name: 'Laisvalaikio naujienos',
        frequency: 'Antradieniais',
        description: 'Įkvepiantys pasakojimai, kelionių idėjos, gamtos naujienos, šeimos gyvenimo įžvalgos, stiliaus patarimai, gardūs receptai.',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/topic_laisvalaikis.png',
        subscribed: false,
        espId: 10286,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'topic',
        name: 'Nuomonių ringas',
        frequency: 'Sekmadieniais',
        description: 'Aktualiausios temos, aštriausios įžvalgos ir netikėtos perspektyvos tiems, kurie nori pažvelgti į pasaulį už savo burbulo ribų.',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/topic_ringas.png',
        subscribed: false,
        espId: 10287,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'topic',
        name: 'Sporto naujienos',
        frequency: 'Antradieniais',
        description: 'Svarbiausios sporto naujienos, rungtynių apžvalgos ir interviu su atletais. Sužinokite, kas vyksta sporto arenoje.',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/topic_sportas.png',
        subscribed: false,
        espId: 10288,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'topic',
        name: 'Savaitės naujienos',
        frequency: 'Šeštadieniais',
        description: 'Kartą per savaitę atrenkame pačius įdomiausius ir aktualiausius straipsnius.',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/topic_savaite.png',
        subscribed: false,
        espId: 9032,
        loading: false,
        subscriberOnly: true,
      },
    ],
  },
  {
    title: 'Pasirinkite pagal autorius',
    description: 'Autoriaus naujienlaiškiai Jus pasieks iškart, kai pasirodys naujas straipsnis.',
    items: [
      {
        type: 'author',
        name: 'Tomas Janonis',
        frequency: null,
        description: '„Delfi“ specialusis korespondentas',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/author_janonis.png',
        subscribed: false,
        espId: 10393,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'author',
        name: 'Dainius Sinkevičius',
        frequency: null,
        description: '„Delfi“ specialusis korespondentas, ciklo „Skandalinga išpažintis“ autorius',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/author_sinkevicius.png',
        subscribed: false,
        espId: 10394,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'author',
        name: 'Vaidas Saldžiūnas',
        frequency: null,
        description: 'Korespondentas gynybos temomis',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/author_saldziunas.png',
        subscribed: false,
        espId: 10395,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'author',
        name: 'Andrius Užkalnis',
        frequency: null,
        description: 'Publicistas',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/author_uzkalnis.png',
        subscribed: false,
        espId: 10396,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'author',
        name: 'Rimvydas Valatka',
        frequency: null,
        description: 'Apžvalgininkas, signataras',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/author_valatka.png',
        subscribed: false,
        espId: 10397,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'author',
        name: 'Lauryna Vireliūnaitė',
        frequency: null,
        description: 'Politikos aktualijų žurnalistė',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/author_vireliunaite.png',
        subscribed: false,
        espId: 10398,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'author',
        name: 'Ana Daukševič',
        frequency: null,
        description: 'Užsienio naujienų korespondentė',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/author_dauksevic.png',
        subscribed: false,
        espId: 10399,
        loading: false,
        subscriberOnly: false,
      },
      {
        type: 'author',
        name: 'Vidas Rachlevičius',
        frequency: null,
        description: 'Apžvalgininkas',
        image: 'https://static.delfi.lt/portal/images/customer/newsletters/author_rachlevicius.png',
        subscribed: false,
        espId: 10641,
        loading: false,
        subscriberOnly: false,
      },
    ],
  },
];
